<template>
<m-pageframe
    title="Organization Billing Settings"
>
<v-container
    fluid
>
    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="search"
        v-on:input="update"
        autocomplete="off"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickExportToExcel()"
                >
                    <v-list-item-title>Export to Excel...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-row>
        <v-col>
            <v-select
                label="Payment Method"
                v-model="payment_method"
                :items="$rc.enumChoices('red_chirp_payment_method',true)"
                v-on:change="update"
            />
        </v-col>
         <v-col>
            <v-select
                label="MRR State"
                v-model="mrr_state"
                :items="$rc.enumChoices('mrr_state',true)"
                v-on:change="update"
            />
        </v-col>
    </v-row>

    <v-data-table
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"

        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
            }"

        @click:row="onClickRow"
    >

        <template v-slot:item.has_rate_card_been_customized="{ item }">
            {{prettyPrintCustomized(item.has_rate_card_been_customized)}}
        </template>

        <template v-slot:item.intuit_company_name="{ item }">
            {{prettyPrintCompanyName(item)}}
        </template>

        <template v-slot:item.payment_method="{ item }">
            {{prettyPaymentMethod(item)}}
        </template>

        <template v-slot:item.send_invoice_to_customer_emails="{ item }">
            {{$rc.pretty(item.send_invoice_to_customer_emails,'comma_list')}}
        </template>

        <template v-slot:item.most_recent_invoice_month="{ item }">
            <span
                :style="styleMostRecentInvoiceMonth(item)"
            >
                {{item.most_recent_invoice_month}}
            </span>
        </template>

     </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const Time = require('@/js/time.js');
export default {
    data() {
        return {
            search: '',
            include_auto: true,
            include_manual: true,
            include_non_revenue: true,
            include_archived: false,
            payment_method: 'any_enum_value',
            mrr_state: 'any_enum_value',
            results: [],
            headers: [
                { 'text' : 'Organization', 'value' : 'organization_label' },
                { 'text' : 'MRR State', 'value' : 'mrr_state' },
                { 'text' : 'Payment Method', 'value' : 'payment_method' },
                { 'text' : 'Terms', 'value' : 'payment_terms' },
                { 'text' : 'Rate Card' , 'value' : 'rate_card_label' },
                { 'text' : 'Billing Start Date' , 'value' : 'billing_start_date' },
                { 'text' : 'Email Invoice To' , 'value' : 'send_invoice_to_customer_emails' },
                { 'text' : 'Last Invoice' , 'value' : 'most_recent_invoice_month' },
            ],
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {

            let payment_method = this.payment_method == 'any_enum_value' ? null : this.payment_method;
            let mrr_state = this.mrr_state == 'any_enum_value' ? null : this.mrr_state;


            let params = {
                'full_text': this.search,
                //'invoice_mode': invoice_modes,
                'sort' : 'organization_label:asc',
                'payment_method': payment_method,
                'mrr_state' : mrr_state,
            };

            this.$rc.showSpinner();
            
            this.$rc.listOrganizationRateCards(
                params,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.results = data.results;

                    for ( let i = 0; i < this.results.length; i++ )
                        this.results[i].foo = 'invoice_created';
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        prettyPrintCustomized(val)
        {
            if ( val ) 
                return 'Yes';
            
            return '';
        },

        prettyPrintCompanyName(item)
        {
            if ( item.intuit_customer_id == null ) return '';
            if ( item.intuit_company_name == null ) return '('+item.intuit_customer_id+')';

            return item.intuit_company_name+' ('+item.intuit_customer_id+')';
        },

        onClickRow(item)
        {
            this.$router.push({
                'name': 'admin-billing-one-organization',
                'params' : {
                    'organization_id' : item.organization_id,
                }
            }).catch(e=>{}); // swallow any exception
        },

        prettyPaymentMethod(item) 
        {
            return item.payment_method;
        },

        styleMostRecentInvoiceMonth(item)
        {
            if ( item.most_recent_invoice_month == null )
                return "";

            let today = Time.getISODate(Date.now());
            if ( today.startsWith(item.most_recent_invoice_month) )
            {
                return "font-weight: bold";
            }
            
            return "";
        },

        onClickExportToExcel()
        {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/billing/export-billing',
                    {
                    }
                );
        },
    },

    
}
</script>

<style lang="scss" scoped>
</style>